import HeightCell from './component';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const fields = ['item_height'];

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const { item_height } = props.selectors.getJourneyFields(state, props.journeyId, fields);
    return {
      itemHeight: item_height / 100,
    };
  })
);

export default enhance(HeightCell);
